<template>
  <div class="modal warning fade" :class="{ 'is-open': isShow }">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning">
            <img
              width="48"
              :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`"
            />
            <span class="text">{{ title }}</span>
          </div>
          <div class="action text-right">
            <a @click="close()" class="btn btn-default">取消</a>
            <a @click="confirm()" class="btn btn-primary">確定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConfirmModal",
  data: () => ({
    title: "",
    isShow: false,
    resolve: null,
    reject: null,
  }),
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    close() {
      this.reject && this.reject();
      this.hide();
    },
    confirm() {
      this.resolve && this.resolve();
      this.hide();
    },
  },
  mounted() {
    this.$bus.on("confirm-modal.show", (title, resolve, reject) => {
      this.title = title;
      this.resolve = resolve;
      this.reject = reject;
      this.show();
    });
    this.$once("hook:destroyed", () => this.$bus.off("confirm-modal.show"));
  },
};
</script>
